/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from './server-rrd.component.ngfactory';
import * as import3 from '../../../app/server/server-rrd.component';
import * as import4 from '../../../app/services/response.service';
import * as import5 from '../../../app/services/api.service';
import * as import6 from '@angular/forms';
import * as import7 from '../../../$$_gendir/node_modules/ngx-modal/Modal.ngfactory';
import * as import8 from 'ngx-modal/Modal';
import * as import9 from '../../../app/server/server-transfer.component';
const styles_ServerTransferComponent:any[] = ([] as any[]);
export const RenderType_ServerTransferComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ServerTransferComponent,
  data: {}
}
);
function View_ServerTransferComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'alert-transfer-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'b',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Uwaga!'])),
    (l()(),import0.ɵted((null as any),[' Wyczerpuje się transfer główny w pakiecie! Zapraszamy do zakupu transferu dodatkowego.\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerTransferComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'alert-transfer-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'b',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Uwaga!'])),
    (l()(),import0.ɵted((null as any),[' Wyczerpuje się transfer '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'b',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['dodatkowy'])),
    (l()(),import0.ɵted((null as any),[' w pakiecie! Zapraszamy do zakupu większego transferu dodatkowego.\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerTransferComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'alert-transfer-warning'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'b',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Uwaga!'])),
    (l()(),import0.ɵted((null as any),[' Wyczerpał się transfer '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'b',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['dodatkowy'])),
    (l()(),import0.ɵted((null as any),[' w pakiecie! Zapraszamy do zakupu większego transferu dodatkowego.\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerTransferComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'alert-transfer-error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'b',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Uwaga!'])),
    (l()(),import0.ɵted((null as any),[' Wyczerpano transfer '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'b',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['główny'])),
    (l()(),import0.ɵted((null as any),[' oraz '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'b',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['dodatkowy!'])),
    (l()(),import0.ɵted((null as any),[' Zapraszamy do zakupu większego transferu dodatkowego.\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerTransferComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'alert-transfer-error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'b',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Uwaga!'])),
    (l()(),import0.ɵted((null as any),[' Wyczerpano transfer główny! Zapraszamy do zakupu transferu dodatkowego.\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerTransferComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_3)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_4)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_5)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_6)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_7)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (((co.transferMainProcentile > 0.75) && (co.transferMainProcentile < 1)) && (co.transferAddProcentile == (0 - 1)));
    ck(v,3,0,currVal_0);
    const currVal_1:any = ((co.transferAddProcentile > 0.75) && (co.transferAddProcentile < 1));
    ck(v,6,0,currVal_1);
    const currVal_2:any = (((co.transferMainProcentile > 0.75) && (co.transferMainProcentile < 1)) && (co.transferAddProcentile >= 1));
    ck(v,9,0,currVal_2);
    const currVal_3:any = ((co.transferMainProcentile >= 1) && (co.transferAddProcentile >= 1));
    ck(v,12,0,currVal_3);
    const currVal_4:any = ((co.transferMainProcentile > 1) && (co.transferAddProcentile == (0 - 1)));
    ck(v,15,0,currVal_4);
  },(null as any));
}
function View_ServerTransferComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Główny']))
  ]
  ,(null as any),(null as any));
}
function View_ServerTransferComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Dodatkowy']))
  ]
  ,(null as any),(null as any));
}
function View_ServerTransferComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      'Przychodzący: ',
      '%'
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.parseFloatValues((((<any>(<any>v.parent).parent).context.$implicit.in / (<any>(<any>v.parent).parent).context.$implicit.limit) * 100),2);
    ck(v,1,0,currVal_0);
  });
}
function View_ServerTransferComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      '%'
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.parseFloatValues((((<any>(<any>v.parent).parent).context.$implicit.in / (<any>(<any>v.parent).parent).context.$implicit.limit) * 100),2);
    ck(v,1,0,currVal_0);
  });
}
function View_ServerTransferComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[
      [
        'class',
        'progress-bar progress-bar-success'
      ]
      ,
      [
        'role',
        'progressbar'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgStyle,[
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngStyle: [
        0,
        'ngStyle'
      ]
    },(null as any)),
    import0.ɵpod(['width']),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_13)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_14)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = ck(v,2,0,(('' + (((<any>v.parent).context.$implicit.in / (<any>v.parent).context.$implicit.limit) * 100)) + '%'));
    ck(v,1,0,currVal_0);
    const currVal_1:any = (((<any>v.parent).context.$implicit.in / (<any>v.parent).context.$implicit.limit) > 0.2);
    ck(v,5,0,currVal_1);
    const currVal_2:any = ((((<any>v.parent).context.$implicit.in / (<any>v.parent).context.$implicit.limit) <= 0.2) && (((<any>v.parent).context.$implicit.in / (<any>v.parent).context.$implicit.limit) > 0.03));
    ck(v,8,0,currVal_2);
  },(null as any));
}
function View_ServerTransferComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      'Wychodzący: ',
      '%'
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.parseFloatValues((((<any>(<any>v.parent).parent).context.$implicit.out / (<any>(<any>v.parent).parent).context.$implicit.limit) * 100),2);
    ck(v,1,0,currVal_0);
  });
}
function View_ServerTransferComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      '%'
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.parseFloatValues((((<any>(<any>v.parent).parent).context.$implicit.out / (<any>(<any>v.parent).parent).context.$implicit.limit) * 100),2);
    ck(v,1,0,currVal_0);
  });
}
function View_ServerTransferComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[
      [
        'class',
        'progress-bar progress-bar-info'
      ]
      ,
      [
        'role',
        'progressbar'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgStyle,[
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngStyle: [
        0,
        'ngStyle'
      ]
    },(null as any)),
    import0.ɵpod(['width']),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_16)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_17)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = ck(v,2,0,(('' + (((<any>v.parent).context.$implicit.out / (<any>v.parent).context.$implicit.limit) * 100)) + '%'));
    ck(v,1,0,currVal_0);
    const currVal_1:any = (((<any>v.parent).context.$implicit.out / (<any>v.parent).context.$implicit.limit) > 0.2);
    ck(v,5,0,currVal_1);
    const currVal_2:any = ((((<any>v.parent).context.$implicit.out / (<any>v.parent).context.$implicit.limit) <= 0.2) && (((<any>v.parent).context.$implicit.out / (<any>v.parent).context.$implicit.limit) > 0.03));
    ck(v,8,0,currVal_2);
  },(null as any));
}
function View_ServerTransferComponent_18(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[
      [
        'class',
        'progress-bar progress-bar-success'
      ]
      ,
      [
        'role',
        'progressbar'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgStyle,[
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
      ,{ngStyle: [
        0,
        'ngStyle'
      ]
    },(null as any)),
    import0.ɵpod(['width']),
    (l()(),import0.ɵted((null as any),['\n                                Główny: 100%\n                            ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = ck(v,2,0,'100%');
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_ServerTransferComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),45,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'fa fa-circle'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_10)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_11)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' / ',
      ' (',
      '%)'
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' (',
      '%)'
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' (',
      '%)'
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'td',[[
        'class',
        'button-more button-more-left'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'btn btn-short-plus'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        co.showDetailsTransfer(v.context.$implicit);
        const pd_0:any = ((<any>import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),4).open()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Szczegóły'])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'td',[[
        'class',
        'progress-inline'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        \n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'progress'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_12)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_15)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_18)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n        \n        \n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'td',[[
        'class',
        'button-more button-more-right'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'btn btn-short-plus'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        co.showDetailsTransfer(v.context.$implicit);
        const pd_0:any = ((<any>import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),4).open()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Szczegóły'])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = (v.context.$implicit.type == 'main');
    ck(v,5,0,currVal_0);
    const currVal_1:any = (v.context.$implicit.type == 'additional');
    ck(v,7,0,currVal_1);
    const currVal_10:any = (((v.context.$implicit.in + v.context.$implicit.out) / v.context.$implicit.limit) < 1);
    ck(v,31,0,currVal_10);
    const currVal_11:any = (((v.context.$implicit.in + v.context.$implicit.out) / v.context.$implicit.limit) < 1);
    ck(v,34,0,currVal_11);
    const currVal_12:any = (((v.context.$implicit.in + v.context.$implicit.out) / v.context.$implicit.limit) >= 1);
    ck(v,37,0,currVal_12);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.formatBytes((v.context.$implicit.in + v.context.$implicit.out),0);
    const currVal_3:any = co.formatBytesWithUnlimited(v.context.$implicit.limit,0);
    const currVal_4:any = co.parseFloatValues((((v.context.$implicit.in + v.context.$implicit.out) / v.context.$implicit.limit) * 100),2);
    ck(v,10,0,currVal_2,currVal_3,currVal_4);
    const currVal_5:any = co.formatBytes(v.context.$implicit.in,0);
    const currVal_6:any = co.parseFloatValues(((v.context.$implicit.in / v.context.$implicit.limit) * 100),2);
    ck(v,13,0,currVal_5,currVal_6);
    const currVal_7:any = co.formatBytes(v.context.$implicit.out,0);
    const currVal_8:any = co.parseFloatValues(((v.context.$implicit.out / v.context.$implicit.limit) * 100),2);
    ck(v,16,0,currVal_7,currVal_8);
    const currVal_9:any = v.context.$implicit.start_date;
    ck(v,19,0,currVal_9);
  });
}
function View_ServerTransferComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),39,'div',[[
        'class',
        'row-taller chart-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),36,'table',[
      [
        'cellpadding',
        '0'
      ]
      ,
      [
        'cellspacing',
        '0'
      ]
      ,
      [
        'class',
        'standard transfer-inner'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),27,'thead',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),24,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Transfer'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Łącznie'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Przychodzące'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wychodzące'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Data rozpoczęcia'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'th',[[
        'class',
        'button-more button-more-left'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',[[
        'class',
        'progress-inline'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Zużycie ruchu sieciowego'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'th',[[
        'class',
        'button-more button-more-right'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_9)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                \n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.transfers;
    ck(v,36,0,currVal_0);
  },(null as any));
}
function View_ServerTransferComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Statystyki ruchu sieciowego dla sieci publicznej'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_2)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_8)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'row-taller chart-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'server-rrd',[[
        'class',
        'chart-inner'
      ]
      ],(null as any),[[
        (null as any),
        'serviceIDChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('serviceIDChange' === en)) {
        const pd_0:any = ((<any>(co.serviceID = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import2.View_ServerRRDComponent_0,import2.RenderType_ServerRRDComponent)),
    import0.ɵdid(4243456,(null as any),0,import3.ServerRRDComponent,[
      import4.ResponseService,
      import5.ApiService
    ]
      ,{serviceID: [
        0,
        'serviceID'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.transfers;
    ck(v,6,0,currVal_0);
    const currVal_1:any = co.transfers;
    ck(v,9,0,currVal_1);
    const currVal_2:any = co.serviceID;
    ck(v,14,0,currVal_2);
  },(null as any));
}
function View_ServerTransferComponent_19(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['głównego']))
  ]
  ,(null as any),(null as any));
}
function View_ServerTransferComponent_20(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['dodatkowego']))
  ]
  ,(null as any),(null as any));
}
function View_ServerTransferComponent_21(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'option',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(147456,(null as any),0,import6.NgSelectOption,[
      import0.ElementRef,
      import0.Renderer,
      [
        2,
        import6.SelectControlValueAccessor
      ]

    ]
      ,{ngValue: [
        0,
        'ngValue'
      ]
    },(null as any)),
    import0.ɵdid(147456,(null as any),0,import6.ɵq,[
      import0.ElementRef,
      import0.Renderer,
      [
        8,
        (null as any)
      ]

    ]
      ,{ngValue: [
        0,
        'ngValue'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit;
    ck(v,1,0,currVal_0);
    const currVal_1:any = v.context.$implicit;
    ck(v,2,0,currVal_1);
  },(ck,v) => {
    const currVal_2:any = v.context.$implicit.name;
    ck(v,3,0,currVal_2);
  });
}
function View_ServerTransferComponent_24(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Główny']))
  ]
  ,(null as any),(null as any));
}
function View_ServerTransferComponent_25(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Dodatkowy']))
  ]
  ,(null as any),(null as any));
}
function View_ServerTransferComponent_23(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),88,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),13,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Typ'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_24)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_25)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Data rozpoczęcia'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Limit'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' łącznie'
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' przychodzących'
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' wychodzących'
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Pakietów łącznie'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Pakietów przychodzących'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Pakietów wychodzących'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.transferForModal.type === 'main');
    ck(v,10,0,currVal_0);
    const currVal_1:any = (co.transferForModal.type === 'additional');
    ck(v,13,0,currVal_1);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.transferForModal.start_date;
    ck(v,23,0,currVal_2);
    const currVal_3:any = co.parseFloatValues((co.transferForModal.limit / co.selectedBytesList.divided),4);
    const currVal_4:any = co.selectedBytesList.symbol;
    ck(v,32,0,currVal_3,currVal_4);
    const currVal_5:any = co.selectedBytesList.name;
    ck(v,38,0,currVal_5);
    const currVal_6:any = co.parseFloatValues(((co.transferForModal.in + co.transferForModal.out) / co.selectedBytesList.divided),4);
    const currVal_7:any = co.selectedBytesList.symbol;
    ck(v,41,0,currVal_6,currVal_7);
    const currVal_8:any = co.selectedBytesList.name;
    ck(v,47,0,currVal_8);
    const currVal_9:any = co.parseFloatValues((co.transferForModal.in / co.selectedBytesList.divided),4);
    const currVal_10:any = co.selectedBytesList.symbol;
    ck(v,50,0,currVal_9,currVal_10);
    const currVal_11:any = co.selectedBytesList.name;
    ck(v,56,0,currVal_11);
    const currVal_12:any = co.parseFloatValues((co.transferForModal.out / co.selectedBytesList.divided),4);
    const currVal_13:any = co.selectedBytesList.symbol;
    ck(v,59,0,currVal_12,currVal_13);
    const currVal_14:any = (co.transferForModal.packets_in + co.transferForModal.packets_out);
    ck(v,68,0,currVal_14);
    const currVal_15:any = co.transferForModal.packets_in;
    ck(v,77,0,currVal_15);
    const currVal_16:any = co.transferForModal.packets_out;
    ck(v,86,0,currVal_16);
  });
}
function View_ServerTransferComponent_22(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),16,'table',[[
        'class',
        'standard pull-right'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,'thead',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Typ'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Dane'])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_23)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.transferForModal;
    ck(v,15,0,currVal_0);
  },(null as any));
}
export function View_ServerTransferComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_1)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),37,'modal',[
      [
        'cancelButtonLabel',
        'Zamknij'
      ]
      ,
      [
        'class',
        'small'
      ]
      ,
      [
        'id',
        'showDetailsTransferModal'
      ]

    ]
    ,(null as any),(null as any),(null as any),import7.View_Modal_0,import7.RenderType_Modal)),
      import0.ɵdid(180224,[[
        'showDetailsTransferModal',
        4
      ]
      ],0,import8.Modal,([] as any[]),{cancelButtonLabel: [
        0,
        'cancelButtonLabel'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),0,11,'modal-header',([] as any[]),(null as any),(null as any),(null as any),import7.View_ModalHeader_0,import7.RenderType_ModalHeader)),
    import0.ɵdid(49152,(null as any),0,import8.ModalHeader,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,7,'h5',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            Szczegółowe dane transferu \n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_19)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_20)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),1,16,'modal-content',([] as any[]),(null as any),(null as any),(null as any),import7.View_ModalContent_0,import7.RenderType_ModalContent)),
    import0.ɵdid(49152,(null as any),0,import8.ModalContent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        Wybierz skalę:\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,9,'select',([] as any[]),[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'change'
      ]
      ,
      [
        (null as any),
        'blur'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import9.ServerTransferComponent = v.component;
      if (('change' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,23).onChange($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,23).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_2:any = ((<any>(co.selectedBytesList = $event)) !== false);
        ad = (pd_2 && ad);
      }
      if (('change' === en)) {
        const pd_3:any = ((<any>co.reloadData()) !== false);
        ad = (pd_3 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.SelectControlValueAccessor,[
      import0.Renderer,
      import0.ElementRef
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.SelectControlValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{model: [
        0,
        'model'
      ]
    },{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.NgModel]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerTransferComponent_21)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_ServerTransferComponent_22)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),2,2,'modal-footer',([] as any[]),(null as any),(null as any),(null as any),import7.View_ModalFooter_0,import7.RenderType_ModalFooter)),
    import0.ɵdid(49152,(null as any),0,import8.ModalFooter,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import9.ServerTransferComponent = v.component;
    const currVal_0:any = co.transfers;
    ck(v,1,0,currVal_0);
    const currVal_1:any = 'Zamknij';
    ck(v,4,0,currVal_1);
    const currVal_2:any = (co.transferForModal && (co.transferForModal.type === 'main'));
    ck(v,12,0,currVal_2);
    const currVal_3:any = (co.transferForModal && (co.transferForModal.type === 'additional'));
    ck(v,15,0,currVal_3);
    const currVal_11:any = co.selectedBytesList;
    ck(v,25,0,currVal_11);
    const currVal_12:any = co.bytesList;
    ck(v,30,0,currVal_12);
    const currVal_13:any = co.transferForModal;
    ck(v,34,0,currVal_13);
  },(ck,v) => {
    const currVal_4:any = import0.ɵnov(v,27).ngClassUntouched;
    const currVal_5:any = import0.ɵnov(v,27).ngClassTouched;
    const currVal_6:any = import0.ɵnov(v,27).ngClassPristine;
    const currVal_7:any = import0.ɵnov(v,27).ngClassDirty;
    const currVal_8:any = import0.ɵnov(v,27).ngClassValid;
    const currVal_9:any = import0.ɵnov(v,27).ngClassInvalid;
    const currVal_10:any = import0.ɵnov(v,27).ngClassPending;
    ck(v,22,0,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10);
  });
}
function View_ServerTransferComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'server-transfer',([] as any[]),(null as any),(null as any),(null as any),View_ServerTransferComponent_0,RenderType_ServerTransferComponent)),
    import0.ɵdid(4243456,(null as any),0,import9.ServerTransferComponent,[
      import5.ApiService,
      import4.ResponseService
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const ServerTransferComponentNgFactory:import0.ComponentFactory<import9.ServerTransferComponent> = import0.ɵccf('server-transfer',import9.ServerTransferComponent,View_ServerTransferComponent_Host_0,{serviceID: 'serviceID'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/server/server-transfer.component.ngfactory.ts